import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import Image from "../Image";

const Side = ({ stage, step = null, startOver }) => {
  const { t } = useTranslation();
  const sideRef = useRef(null);

  return <div ref={sideRef} className={styles.side}>
    <div className={styles.content}>
      <h2>
        {t('tool_ui.global.left_title')}
      </h2>
      <p>
        {t('tool_ui.global.left_subtitle')}
      </p>
      <button onClick={startOver} className={styles.button}>
        <Image src={'images_iax/icon-cog'} type={'svg'} className={styles.icon} />
        {t('tool_ui.global.start_over')}
      </button>
    </div>
    <div className={styles.spacer}></div>
    {step ? <div className={styles.did_you_know}>
      <h3>
        {t('tool_ui.global.dyk_title')}
      </h3>
      <p>
        {t('tool_ui.' + stage.key + '.' + step.key + '_dyk')}
      </p>
    </div> : ''}
  </div>;
}

export default Side;
